(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-care"] && !Shopify.designMode) return;
  try {
    
  class MyCarePortal extends HTMLElement {
    #frame = null;
    #status = null;
    #portalOrigin = null;
    #verificationCode = null;
    #retriesLeft = 1;
    #controller = null;

    connectedCallback() {
      this.#frame = this.querySelector('[data-my-care-frame]');
      this.#status = this.querySelector('[data-my-care-status]');
      if (!this.#frame || !this.#status) return;

      window.addEventListener('message', this.#onMessage);
      this.#load();
    }

    disconnectedCallback() {
      window.removeEventListener('message', this.#onMessage);
      this.#controller?.abort();
    }

    async #load() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      this.#portalOrigin = null;
      this.#verificationCode = null;

      try {
        const response = await fetch(this.dataset.sessionUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: this.#controller.signal,
        });
        if (!response.ok) throw new Error(`My Care session request failed with HTTP ${response.status}`);

        const session = await response.json();
        const portalUrl = new URL(session?.url);
        if (portalUrl.protocol !== 'https:') {
          throw new Error('My Care session response is missing a valid url');
        }
        // Live MDI returns a pre-authenticated guest link with no code; the
        // otp_ready handshake below only runs when a code was provided.
        const code = session?.verification_code;

        this.#portalOrigin = portalUrl.origin;
        this.#verificationCode = typeof code === 'string' && code !== '' ? code : null;
        this.#frame.addEventListener('load', this.#onFrameLoad, { once: true });
        this.#frame.src = portalUrl.href;
        this.#frame.hidden = false;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        console.error(error);
        this.#showError();
      }
    }

    #onFrameLoad = () => {
      this.#status.hidden = true;
    };

    #onMessage = (event) => {
      const frameWindow = this.#frame.contentWindow;
      if (!this.#portalOrigin || event.origin !== this.#portalOrigin || event.source !== frameWindow) return;

      const type = event.data?.event;
      if (type === 'otp_ready' && this.#verificationCode) {
        frameWindow.postMessage({ message: 'otp', data: this.#verificationCode }, this.#portalOrigin);
      } else if (type === 'otp_failed') {
        if (this.#retriesLeft > 0) {
          this.#retriesLeft -= 1;
          this.#load();
        } else {
          this.#showError();
        }
      }
    };

    #showError() {
      this.#frame.removeEventListener('load', this.#onFrameLoad);
      this.#frame.hidden = true;
      this.#frame.removeAttribute('src');
      this.#status.textContent = this.dataset.errorText;
      this.#status.hidden = false;
    }
  }

  if (!customElements.get('my-care-portal')) {
    customElements.define('my-care-portal', MyCarePortal);
  }

  } catch(e) { console.error(e); }
})();
})();
